/**
 * Web Style Import
 *
 */

import './style/dnb-skip-content.scss'
